import { call, put, select, take } from "redux-saga/effects";

import { history } from "state/history";
import { closeLoadingFrame } from "state/app/actions";

import { fetchAll } from "state/teachers/actions";
import {isCheckoutWindowOpen} from "state/school_money/selectors";
import {getSchoolIDFromRemoteSchoolID} from "state/teachers/selectors";

// Prevents app refresh if CheckoutWindow is open
function* waitForCheckoutWindowToClose(){
  while ((yield select(isCheckoutWindowOpen))) {
    yield take();
  }
}

/**
 * Called when we are responding to a notification being clicked
 *   (or some similar event from the native client)
 */
export default function* processMetadataSaga(action) {

  let notificationType;
  let schoolID = "";
  let metadata;
  let remoteSchoolID;

  yield call(waitForCheckoutWindowToClose);

  // Check for empty metadata passed from native
  if (action.payload.metadata === "") {
    return;
  }
  
  // `refresh` is sent as string from native app side if no valid notificaiton type is sent, so deal with it first
  if (action.payload.metadata === "refresh") {
    yield put(fetchAll());
    yield put(closeLoadingFrame());
    return;
  }

  // Handle both old and new type of meta data from t2p notification
  try {
    metadata = JSON.parse(action.payload.metadata);
    notificationType = metadata.type;
    remoteSchoolID = metadata.school_id;

    // Get the school id for app using the remote schoolid, and add / to the end
    schoolID = yield select(getSchoolIDFromRemoteSchoolID, remoteSchoolID);
    schoolID = schoolID + "/";
  } catch (err) {
    notificationType = action.payload.metadata;
  }

  if (metadata !== undefined && metadata.application !== "teachers") {
    yield put(closeLoadingFrame());
    return;
  }

  // the metadata property tells us what to do
  switch (notificationType) {

    case "notice":
      history.push("/teachers/noticeboard/" + schoolID);
      yield put(fetchAll());
      break;

    case "message":
      history.push("/teachers/messages/" + schoolID);
      yield put(fetchAll());
      break;

    default:
      break;
  }

  yield put(closeLoadingFrame());

}



// WEBPACK FOOTER //
// ./src/state/teachers/sagas/processMetadataSaga.js